import React from 'react';
import { Modal, ProgressBar} from 'react-bootstrap';

const ProgressModal = ({ progressModalShow, onClose, progress }) => {
  return (
    <Modal show={progressModalShow} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>Validating HCP Files..</Modal.Title>
      </Modal.Header>
      <Modal.Body  style={{ height: '120px'}}>
      <p>Please Wait...</p>
        <ProgressBar now={progress} label={`${progress}%`}  striped />
        {/* <span className="progress-description">
        Validation in progress. Do not close.
          </span> */}
      </Modal.Body>
    </Modal>
  );
};

export default ProgressModal;
